import { createAsyncThunk } from "@reduxjs/toolkit"

import { ErrorsActions } from "../../../Redux/redux/errors.slice"
import { getApiErrorMessage, handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../api/services"
import { RECEIPT_SLICE_NAME as SLICE_NAME } from "./receipt.constants"

export const getReceiptState = createAsyncThunk(
  `${SLICE_NAME}/get_state`,
  async (businessId, { dispatch, rejectWithValue }) => {
    const response = await services.getReceiptState({ business_account_id: businessId })
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getReceiptKpi = createAsyncThunk(
  `${SLICE_NAME}/get_kpi`,
  async ({ businessId, selectedProgram, channel } = {}, { dispatch, rejectWithValue }) => {
    const response = await services.getReceiptKpi({
      business_account_id: businessId,
      program: selectedProgram || "all",
      channel: channel || ""
    })
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getReceiptLookups = createAsyncThunk(
  `${SLICE_NAME}/get_lookups`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getReceiptLookups(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getReceiptExport = createAsyncThunk(
  `${SLICE_NAME}/get_export`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getReceiptExport(params)
    if (!response.ok) {
      // Both export refusals arrive as a bare `{"Export canceled": "..."}` body — no `message` or
      // `detail` for `getApiErrorMessage` to resolve, so `handleApiError` would notify nothing and
      // the click would look like it silently did nothing. The raw body goes to the notification
      // instead, which renders each key as its own title and description; that is how the alerts,
      // credit-request and admin Receipt exports show the same refusal.
      const message = await getApiErrorMessage(response)
      if (message) await handleApiError(dispatch, response)
      else dispatch(ErrorsActions.errorSave(response.data))
      return rejectWithValue(message ?? response.data)
    }
    return response.data
  }
)

// Not wired to any slice — dispatched only to consume via `.unwrap()` in the
// component. Kept as a thunk so the real endpoint swap-in only touches the
// service layer.
export const getReceiptFaqThunk = createAsyncThunk(
  "receiptFaq/get",
  async (_, { dispatch, rejectWithValue }) => {
    const response = await services.getReceiptFaq()
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
